import { createElement } from 'react';
import PropTypes from 'prop-types';

const Small = ({ className, useBareClass, children, ...props }) =>
  createElement(
    'small',
    {
      ...props,
      className: useBareClass ? className : `body-4 ${className}`
    },
    children
  );

Small.defaultProps = {
  className: '',
  useBareClass: false
};

Small.propTypes = {
  className: PropTypes.string,
  useBareClass: PropTypes.bool,
  children: PropTypes.any.isRequired
};

export default Small;
